import { connect } from 'react-redux'
import GearModelsUploadComponent from '../components/GearModelsUploadComponent.jsx';
import {
  uploadModelTemplate,
  changeGearModelValue,
  updateModelType
} from '../actions';

const mapStateToProps = (state) => ({
  gearModel: state.getIn(['gearModelReducer', 'gearModel']),
  gearModelValidation: state.getIn(['gearModelReducer', 'gearModelValidation']),
  alertStyle: state.getIn(['gearModelReducer', 'alertStyle']),
  alertMessage: state.getIn(['gearModelReducer', 'alertMessage']),
  activePage: state.getIn(['gearModelListReducer', 'activePage']),
  itemPerPage: state.getIn(['gearModelListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
  uploadModelTemplate: (modelNo, templateType, uploadOrdererFile, pagingData) => {
    dispatch(uploadModelTemplate(modelNo, templateType, uploadOrdererFile, pagingData));
  },
  setValue: (id, value) => {
    dispatch(changeGearModelValue({
      id: id,
      value: value
    }))
  },
  updateModelType: (gearModel, pagingData) => {
    dispatch(updateModelType(gearModel, pagingData));
  }
})

const GearModelsUploadContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GearModelsUploadComponent)

export default GearModelsUploadContainer;


// WEBPACK FOOTER //
// ./src/containers/GearModelsUploadContainer.jsx